export default __webpack_public_path__ + "static/media/216property-gallery2.b62883e3.webp";